import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import IncompleteSetupTooltipMessage from 'FormsUI/components/editor/options/payment/IncompleteSetupTooltipMessage';
import NoPermissionsTooltipMessage from 'FormsUI/components/editor/options/payment/NoPermissionsTooltipMessage';
import TicketPropertiesEnabledTooltipMessage from 'FormsUI/components/editor/options/payment/TicketPropertiesEnabledTooltipMessage';
import FormRoutingEnabledTooltipMessage from 'FormsUI/components/editor/options/payment/FormRoutingEnabledTooltipMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getToggleTooltipTitle = (shouldShowPermissionsTooltip = false, shouldShowPaymentsTooltip = false, isTicketPropertiesEnabled = false, isFormRoutingEnabled = false) => {
  if (shouldShowPermissionsTooltip) return /*#__PURE__*/_jsx(NoPermissionsTooltipMessage, {});
  if (shouldShowPaymentsTooltip) return /*#__PURE__*/_jsx(IncompleteSetupTooltipMessage, {});
  if (isTicketPropertiesEnabled) return /*#__PURE__*/_jsx(TicketPropertiesEnabledTooltipMessage, {});
  if (isFormRoutingEnabled) return /*#__PURE__*/_jsx(FormRoutingEnabledTooltipMessage, {});
  return null;
};
const PaymentToggle = ({
  isDisabled = true,
  isToggled = false,
  onChange = () => {}
}) => /*#__PURE__*/_jsx(Toggle, {
  disabled: isDisabled,
  "data-test-id": "payment-option",
  checked: isToggled,
  size: "extra-small",
  onChange: onChange
});
const PaymentToggleLocked = args => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-payments-upgrade');
  return /*#__PURE__*/_jsx(PaymentToggle, Object.assign({}, args, {
    isDisabled: false,
    onChange: openUpgradeModal
  }));
};
const PaymentLockBadge = () => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-payments-upgrade');
  return /*#__PURE__*/_jsx(Link, {
    onClick: openUpgradeModal,
    children: /*#__PURE__*/_jsx(LockBadge, {
      size: "xs",
      marginBlockStart: "100",
      marginInlineEnd: "400"
    })
  });
};
const PaymentToggleContainer = ({
  isPaymentLockBadgeShown = false,
  shouldShowPaymentsTooltip,
  shouldShowPermissionsTooltip,
  isTicketPropertiesEnabled,
  isFormRoutingEnabled,
  isToggled,
  onChange
}) => {
  const isPaymentsToggleDisabled = shouldShowPaymentsTooltip || shouldShowPermissionsTooltip || (isTicketPropertiesEnabled || isFormRoutingEnabled) && !isToggled;
  const PaymentToggleComponent = isPaymentLockBadgeShown ? PaymentToggleLocked : PaymentToggle;
  return /*#__PURE__*/_jsxs(TFlex, {
    children: [isPaymentLockBadgeShown && /*#__PURE__*/_jsx(PaymentLockBadge, {}), /*#__PURE__*/_jsx(Tooltip, {
      title: getToggleTooltipTitle(shouldShowPermissionsTooltip, shouldShowPaymentsTooltip, isTicketPropertiesEnabled, isFormRoutingEnabled),
      placement: "right",
      disabled: !isPaymentsToggleDisabled,
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(PaymentToggleComponent, {
          isDisabled: isPaymentsToggleDisabled,
          isToggled: isToggled,
          onChange: onChange
        })
      })
    })]
  });
};
export default PaymentToggleContainer;